import { isHotelRole } from '../../../constants/roles';
import { Hotel } from '../../../hooks/useHotels';

export const canShowGBTAUpload = (hotel: Hotel) => {
  // const eligibleStatuses = ['COMPLETE ASSESSMENT', 'COMPLETE_ASSESSMENT'];
  // return eligibleStatuses.includes(hotel.alo_submission_status) || eligibleStatuses.includes(hotel.alo_resubmission_status ?? '');
  return hotel.userPermissions.canShowGBTA;
};

export const showApproveScoreToAdmin = (hotel: any, user: any) => {
  const showForStatuses = [
    'APPROVAL SCORE',
    'RELEASED TO HOTEL',
    'APPROVAL_SCORE',
    'RELEASED_TO_HOTEL',
  ];

  return (
    isHotelRole(user?.role) &&
    showForStatuses.includes(hotel.alo_submission_status)
  );
};
export const showPublishButtonToAdmin = (hotel: any, user: any) => {
  const showForStatuses = ['APPROVED SCORE', 'APPROVED_SCORE'];

  return (
    isHotelRole(user?.role) &&
    showForStatuses.includes(hotel.alo_submission_status)
  );
};
